"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("motion/react");
const SlideAndFadeTransition = ({ duration = 3.2, children, }) => {
    if ((0, react_1.useReducedMotionConfig)()) {
        return (0, jsx_runtime_1.jsx)("div", { children: children });
    }
    return ((0, jsx_runtime_1.jsx)(react_1.motion.div, { layout: true, initial: { y: -200, opacity: 0 }, animate: {
            y: [-200, 0, 0, -200],
            opacity: [0, 1, 1, 0],
        }, transition: {
            duration,
            times: [0, 0.07, 0.4, 0.7],
            ease: ['easeOut', 'linear', 'easeInOut'],
        }, children: children }));
};
exports.default = SlideAndFadeTransition;
